import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-fontEnlargement",
  "use": "icon-fontEnlargement-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-fontEnlargement\"><path d=\"M631.1 266.9h152.2v41H631.1zm193.2 0h152.2v41H824.3zm-41 40.9h41V460h-41zm0-193.2h41v152.2h-41z\" /><path d=\"M783.3 266.9h41v41h-41zM368.5 150.5L57.2 855.2h73.2l101.3-236.8h346.7l98.9 236.8h78.1L444.2 150.5h-75.7zM559 572H251.3l54.9-127.6c35.4-82.2 65.9-156.6 96.4-241.7h4.9c31.7 85.1 61 159.5 97.7 241.7L559 572z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol